export const EXPERIENCE_NAME_PREFIX = 'embedded-confluence/';

export enum ExperienceNames {
	VIEW_PAGE = 'embedded-confluence/view-page',
	CC_VIEW_PAGE = 'view-page',

	EDIT_PAGE = 'embedded-confluence/edit-page',
	CC_EDIT_PAGE_EMBED = 'edit-page-embed',

	WHITEBOARD = 'embedded-confluence/whiteboard',
	CC_WHITEBOARD = 'whiteboard-page',

	LOGIN_PAGE = 'embedded-confluence/login-page',
	STORAGE_ACCESS_PAGE = 'embedded-confluence/storage-access-page',

	PAGE_NOT_FOUND = 'not-found',
}

export enum ExperienceReasons {
	UNABLE_TO_DISPLAY_CONTENT = 'Unable to display page content',
	STORAGE_ACCESS_ERROR = 'Error when obtaining Storage access',
	STORAGE_ACCESS_NOT_SUPPORTED = 'Storage access API is not supported',
	STORAGE_ACCESS_REJECTED = 'Storage access is rejected',
}
